// @ts-check
import Tooltip from '@material-ui/core/Tooltip';
import history from 'common/RouterHistory';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';
import Icon from 'components/base/Icon';
import isEmpty from 'lodash/isEmpty';
import useRBACPermissions from 'views/root/views/home/hooks/useRBACPermissions';
import { LBButton } from '@linearb/buzz';

const EditSettings = ({
  goToSettings,
  selectTeamId,
  globallySelectedTeamId,
  widgetId
}) => {
  const { tooltip, goTo, isUsingPmSensor = false } = goToSettings;
  const pmSensor = useSelector(pmIntegrationSelector);
  const { isPermitted } = useRBACPermissions();
  const showSettingsIcon = !isUsingPmSensor || pmSensor;

  if (
    isEmpty(goToSettings) ||
    !showSettingsIcon ||
    (!isPermitted && !goToSettings.showGoToSettings)
  ) {
    return null;
  }

  return (
    <Tooltip
      title={tooltip}
      placement='top'
      data-testid='setting-button-tooltip'
    >
      <LBButton
        variant='ghost'
        size='icon'
        onClick={() =>
          goTo(
            history,
            pmSensor,
            selectTeamId,
            globallySelectedTeamId,
            widgetId
          )
        }
        data-testid={goToSettings.dataTestid}
        data-cy={`pinned-settings-icon-${widgetId}`}
      >
        <Icon name='settings' />
      </LBButton>
    </Tooltip>
  );
};

export default EditSettings;
